// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

import { Uuid, UuidT, verifyUuid } from "../front-end/uuid";

/**
 * A building floor plan map with overlay configuration.
 */
export class Map implements flatbuffers.IUnpackableObject<MapT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): Map {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsMap(bb: flatbuffers.ByteBuffer, obj?: Map): Map {
    return (obj || new Map()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  static getSizePrefixedRootAsMap(bb: flatbuffers.ByteBuffer, obj?: Map): Map {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new Map()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  id(obj?: Uuid): Uuid | null {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset
      ? (obj || new Uuid()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!)
      : null;
  }

  orgId(obj?: Uuid): Uuid | null {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return offset
      ? (obj || new Uuid()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!)
      : null;
  }

  name(): string | null;
  name(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  name(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 8);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  s3Url(): string | null;
  s3Url(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  s3Url(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 10);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  offlineUrl(): string | null;
  offlineUrl(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  offlineUrl(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 12);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  /**
   * JSON-encoded pin/overlay configuration.
   */
  setupJson(): string | null;
  setupJson(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  setupJson(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 14);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  /**
   * Whether this is the default/start map for the org.
   */
  start(): boolean {
    const offset = this.bb!.__offset(this.bb_pos, 16);
    return offset ? !!this.bb!.readInt8(this.bb_pos + offset) : false;
  }

  createdAt(): string | null;
  createdAt(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  createdAt(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 18);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  updatedAt(): string | null;
  updatedAt(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  updatedAt(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 20);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  deletedAt(): string | null;
  deletedAt(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  deletedAt(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 22);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  static startMap(builder: flatbuffers.Builder) {
    builder.startObject(10);
  }

  static addId(builder: flatbuffers.Builder, idOffset: flatbuffers.Offset) {
    builder.addFieldOffset(0, idOffset, 0);
  }

  static addOrgId(builder: flatbuffers.Builder, orgIdOffset: flatbuffers.Offset) {
    builder.addFieldOffset(1, orgIdOffset, 0);
  }

  static addName(builder: flatbuffers.Builder, nameOffset: flatbuffers.Offset) {
    builder.addFieldOffset(2, nameOffset, 0);
  }

  static addS3Url(builder: flatbuffers.Builder, s3UrlOffset: flatbuffers.Offset) {
    builder.addFieldOffset(3, s3UrlOffset, 0);
  }

  static addOfflineUrl(builder: flatbuffers.Builder, offlineUrlOffset: flatbuffers.Offset) {
    builder.addFieldOffset(4, offlineUrlOffset, 0);
  }

  static addSetupJson(builder: flatbuffers.Builder, setupJsonOffset: flatbuffers.Offset) {
    builder.addFieldOffset(5, setupJsonOffset, 0);
  }

  static addStart(builder: flatbuffers.Builder, start: boolean) {
    builder.addFieldInt8(6, +start, +false);
  }

  static addCreatedAt(builder: flatbuffers.Builder, createdAtOffset: flatbuffers.Offset) {
    builder.addFieldOffset(7, createdAtOffset, 0);
  }

  static addUpdatedAt(builder: flatbuffers.Builder, updatedAtOffset: flatbuffers.Offset) {
    builder.addFieldOffset(8, updatedAtOffset, 0);
  }

  static addDeletedAt(builder: flatbuffers.Builder, deletedAtOffset: flatbuffers.Offset) {
    builder.addFieldOffset(9, deletedAtOffset, 0);
  }

  static endMap(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    return offset;
  }

  unpack(): MapT {
    return new MapT(
      this.id() !== null ? this.id()!.unpack() : null,
      this.orgId() !== null ? this.orgId()!.unpack() : null,
      this.name(),
      this.s3Url(),
      this.offlineUrl(),
      this.setupJson(),
      this.start(),
      this.createdAt(),
      this.updatedAt(),
      this.deletedAt(),
    );
  }

  unpackTo(_o: MapT): void {
    _o.id = this.id() !== null ? this.id()!.unpack() : null;
    _o.orgId = this.orgId() !== null ? this.orgId()!.unpack() : null;
    _o.name = this.name();
    _o.s3Url = this.s3Url();
    _o.offlineUrl = this.offlineUrl();
    _o.setupJson = this.setupJson();
    _o.start = this.start();
    _o.createdAt = this.createdAt();
    _o.updatedAt = this.updatedAt();
    _o.deletedAt = this.deletedAt();
  }

  unpackFields(...fields: string[]): MapT {
    const t = new MapT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("id")) {
      t.id = this.id() !== null ? this.id()!.unpack() : null;
    }
    if (fieldSet.has("org_id")) {
      t.orgId = this.orgId() !== null ? this.orgId()!.unpack() : null;
    }
    if (fieldSet.has("name")) {
      t.name = this.name();
    }
    if (fieldSet.has("s3_url")) {
      t.s3Url = this.s3Url();
    }
    if (fieldSet.has("offline_url")) {
      t.offlineUrl = this.offlineUrl();
    }
    if (fieldSet.has("setup_json")) {
      t.setupJson = this.setupJson();
    }
    if (fieldSet.has("start")) {
      t.start = this.start();
    }
    if (fieldSet.has("created_at")) {
      t.createdAt = this.createdAt();
    }
    if (fieldSet.has("updated_at")) {
      t.updatedAt = this.updatedAt();
    }
    if (fieldSet.has("deleted_at")) {
      t.deletedAt = this.deletedAt();
    }
    return t;
  }
}

export class MapT implements flatbuffers.IGeneratedObject {
  constructor(
    public id: UuidT | null = null,
    public orgId: UuidT | null = null,
    public name: string | Uint8Array | null = null,
    public s3Url: string | Uint8Array | null = null,
    public offlineUrl: string | Uint8Array | null = null,
    public setupJson: string | Uint8Array | null = null,
    public start: boolean = false,
    public createdAt: string | Uint8Array | null = null,
    public updatedAt: string | Uint8Array | null = null,
    public deletedAt: string | Uint8Array | null = null,
  ) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    const id = this.id !== null ? this.id!.pack(builder) : 0;
    const orgId = this.orgId !== null ? this.orgId!.pack(builder) : 0;
    const name = this.name !== null ? builder.createString(this.name!) : 0;
    const s3Url = this.s3Url !== null ? builder.createString(this.s3Url!) : 0;
    const offlineUrl = this.offlineUrl !== null ? builder.createString(this.offlineUrl!) : 0;
    const setupJson = this.setupJson !== null ? builder.createString(this.setupJson!) : 0;
    const createdAt = this.createdAt !== null ? builder.createString(this.createdAt!) : 0;
    const updatedAt = this.updatedAt !== null ? builder.createString(this.updatedAt!) : 0;
    const deletedAt = this.deletedAt !== null ? builder.createString(this.deletedAt!) : 0;

    Map.startMap(builder);
    Map.addId(builder, id);
    Map.addOrgId(builder, orgId);
    Map.addName(builder, name);
    Map.addS3Url(builder, s3Url);
    Map.addOfflineUrl(builder, offlineUrl);
    Map.addSetupJson(builder, setupJson);
    Map.addStart(builder, this.start);
    Map.addCreatedAt(builder, createdAt);
    Map.addUpdatedAt(builder, updatedAt);
    Map.addDeletedAt(builder, deletedAt);

    return Map.endMap(builder);
  }

  clone(): MapT {
    const obj = new MapT();
    obj.id = this.id !== null ? this.id!.clone() : null;
    obj.orgId = this.orgId !== null ? this.orgId!.clone() : null;
    obj.name = this.name;
    obj.s3Url = this.s3Url;
    obj.offlineUrl = this.offlineUrl;
    obj.setupJson = this.setupJson;
    obj.start = this.start;
    obj.createdAt = this.createdAt;
    obj.updatedAt = this.updatedAt;
    obj.deletedAt = this.deletedAt;
    return obj;
  }

  equals(other: MapT): boolean {
    if (this.id !== null && other.id !== null) {
      if (!this.id!.equals(other.id!)) return false;
    } else if (this.id !== other.id) return false;
    if (this.orgId !== null && other.orgId !== null) {
      if (!this.orgId!.equals(other.orgId!)) return false;
    } else if (this.orgId !== other.orgId) return false;
    if (this.name !== other.name) return false;
    if (this.s3Url !== other.s3Url) return false;
    if (this.offlineUrl !== other.offlineUrl) return false;
    if (this.setupJson !== other.setupJson) return false;
    if (this.start !== other.start) return false;
    if (this.createdAt !== other.createdAt) return false;
    if (this.updatedAt !== other.updatedAt) return false;
    if (this.deletedAt !== other.deletedAt) return false;
    return true;
  }
}

export function verifyMap(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    {
      const fieldPos = verifier.checkOffsetField(tablePos, 4);
      if (fieldPos !== 0) {
        const tableOffset = verifier.readInt32(fieldPos);
        verifyUuid(verifier, fieldPos + tableOffset);
      }
    }
    {
      const fieldPos = verifier.checkOffsetField(tablePos, 6);
      if (fieldPos !== 0) {
        const tableOffset = verifier.readInt32(fieldPos);
        verifyUuid(verifier, fieldPos + tableOffset);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 8);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 10);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 12);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 14);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    verifier.checkScalarField(tablePos, 16, 1);
    {
      const pos = verifier.checkOffsetField(tablePos, 18);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 20);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 22);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
  } finally {
    verifier.popDepth();
  }
}
